module.exports = __webpack_public_path__ + "img/zona3.802973fb.jpg";